export default "__VITE_ASSET__g0$sgyzc__"